import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-bpams-applications-bpi.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-bpams-applications-bpi.component.scss?ngResource";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { throwError } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import { AppControllerService } from "../../../../../app-controller.service";
import { ViewApplicationService } from "../../../view-application.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { catchError, map, take } from "rxjs/operators";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { LinkedBpApplicationsHeadingEnum, LinkedBpApplicationsHeadingEnumLookup } from "./model/view-application-bpams-applications-bpi-table.constant";
import { SaShortDatePipe } from "../../../../../shared/pipes/sa-short-date/sa-short-date.pipe";
import { ViewApplicationBpamsApplicationsBpiConstants } from "./view-application-bpams-applications-bpi.constants";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { ApplicationsRoutingConstants } from "../../../../../tabs/applications/applications-routing.constants";
import { AlertType } from "../../../../../shared/models/alert";
let ViewApplicationBpamsApplicationsBpiComponent = class ViewApplicationBpamsApplicationsBpiComponent extends ApplicationBaseComponent {
    router;
    route;
    appController;
    viewApplicationService;
    aflaModuleStrategyService;
    saShortDatePipe;
    routerParamsService;
    tableHeader;
    dataSource;
    linkText = LinkedBpApplicationsHeadingEnum.links;
    defaultSortColumn = {
        column: LinkedBpApplicationsHeadingEnum.startedDate,
        direction: "desc"
    };
    btnRemoveLink = ViewApplicationBpamsApplicationsBpiConstants.REMOVE_LINK_LABEL;
    btnLink = ViewApplicationBpamsApplicationsBpiConstants.LINK_LABEL;
    selectedItems = [];
    constructor(router, route, appController, viewApplicationService, aflaModuleStrategyService, saShortDatePipe, routerParamsService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.router = router;
        this.route = route;
        this.appController = appController;
        this.viewApplicationService = viewApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.saShortDatePipe = saShortDatePipe;
        this.routerParamsService = routerParamsService;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initializeTableHeaders();
    }
    handleRouteChange() {
        this.fetchApplications();
    }
    initializeTableHeaders() {
        this.tableHeader = LinkedBpApplicationsHeadingEnumLookup;
    }
    fetchApplications() {
        this.selectedItems = [];
        const params = {
            moduleId: +this.moduleID,
            jobId: +this.jobID
        };
        this.dataSource = this.viewApplicationService.getBpiBpLinkedApplications(params)
            .pipe(map(result => {
            const values = [];
            result.linkApplications.forEach(item => {
                const linkView = {
                    id: item.id,
                    jobId: item.jobId,
                    moduleId: item.moduleId,
                    referenceNumber: item.referenceNumber,
                    applicant: item.applicant,
                    startedDate: item.startedDate !== null ? this.saShortDatePipe.transform(item.startedDate) : "",
                    createdDate: item.createdDate !== null ? this.saShortDatePipe.transform(item.createdDate) : "",
                    status: item.status,
                    description: item.description,
                    linked: item.linked,
                    applicationType: item.applicationType,
                    link: "Open application"
                };
                values.push(linkView);
            });
            return values.sort((a, b) => 0 - (a.linked.toLowerCase() > b.linked.toLowerCase() ? 1 : -1));
        }), catchError(error => {
            this.appController.handleServerErrorMessage(ViewApplicationBpamsApplicationsBpiConstants.STEP_TITLE, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    onURLClicked(tableItem) {
        this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
            this.router.navigate([
                AppRoutingConstants.ROUTE_SEPERATOR + ApplicationsRoutingConstants.REFRESH_ROUTE,
                {
                    jobId: tableItem.jobId.toString(),
                    moduleId: tableItem.moduleId.toString(),
                    type: ApplicationsRoutingConstants.REFRESH_VIEW_APPLICATION_ROUTE
                }
            ]);
        });
    }
    itemsSelected(array) {
        this.selectedItems = array;
    }
    onBtnRemoveLink() {
        if (this.selectedItems.length === 0) {
            this.appController.showMessage(ViewApplicationBpamsApplicationsBpiConstants.NO_APPLICATIONS_SELECTED, AlertType.Warning);
            return;
        }
        const ids = [];
        this.selectedItems.forEach(item => {
            ids.push(item.id);
        });
        const params = {
            moduleId: +this.moduleID,
            jobId: +this.jobID,
            bpApplicationIds: ids
        };
        this.viewApplicationService.postBpiDelinkedApplications(params).pipe(take(1)).subscribe({
            next: result => {
                this.appController.showMessage(ViewApplicationBpamsApplicationsBpiConstants.APPLICATIONS_DELINKED, AlertType.Success);
                this.fetchApplications();
            },
            error: error => {
                this.appController.handleServerErrorMessage(ViewApplicationBpamsApplicationsBpiConstants.STEP_TITLE, error, CRUDOperation.Add);
            }
        });
    }
    onBtnLink() {
        if (this.selectedItems.length === 0) {
            this.appController.showMessage(ViewApplicationBpamsApplicationsBpiConstants.NO_APPLICATIONS_SELECTED, AlertType.Warning);
            return;
        }
        const ids = [];
        this.selectedItems.forEach(item => {
            ids.push(item.id);
        });
        const params = {
            moduleId: +this.moduleID,
            jobId: +this.jobID,
            bpApplicationIds: ids
        };
        this.viewApplicationService.postBpiLinkBpApplications(params).pipe(take(1)).subscribe({
            next: result => {
                this.appController.showMessage(ViewApplicationBpamsApplicationsBpiConstants.APPLICATIONS_LINKED, AlertType.Success);
                this.fetchApplications();
            },
            error: error => {
                this.appController.handleServerErrorMessage(ViewApplicationBpamsApplicationsBpiConstants.STEP_TITLE, error, CRUDOperation.Add);
            }
        });
    }
    static ctorParameters = () => [
        { type: Router },
        { type: ActivatedRoute },
        { type: AppControllerService },
        { type: ViewApplicationService },
        { type: AflaModuleStrategyService },
        { type: SaShortDatePipe },
        { type: RouterParamsService }
    ];
};
ViewApplicationBpamsApplicationsBpiComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-bpams-applications-bpi",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationBpamsApplicationsBpiComponent);
export { ViewApplicationBpamsApplicationsBpiComponent };
